import "bootstrap/dist/css/bootstrap.min.css";
import React, { useState, lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import "./App.css";
import Loader from "../utils/Loader";

// Lazy-loaded components
const Dashboard = lazy(() => import("./Dashboard/Dashboard"));
const Header = lazy(() => import("./Shared/Header"));
const Sidebar = lazy(() => import("./Shared/Sidebar"));
const Footer = lazy(() => import("./Shared/Footer"));
const UserList = lazy(() => import("./UserList/UserList"));
const ProtectedRoute = lazy(() => import("./Auth/ProtectedRoute"));
const ArticleFrobes = lazy(() => import("./templates/ArticleFrobes"));
const ArticleCXO = lazy(() => import("./templates/ArticleCXO"));
const WebTemplate = lazy(() => import("./website/WebTemplate"));
const GoogleTemplate = lazy(() => import("./templates/GoogleTemplate"));
const Home = lazy(() => import("./report/Home"));

function AdminApp() {
  const [isSidebarVisible, setIsSidebarVisible] = useState(false);
  const toggleSidebar = () => setIsSidebarVisible(!isSidebarVisible);
  
  // Render /admin/templates as pure standalone (no layout at all)
  const location = useLocation();
  // if (location.pathname === "/admin/templates/forbes") {
  if (location.pathname.startsWith("/admin/templates/forbes")) {
    return (
        <Routes>
          <Route
            path="templates/forbes/:id"
            element={
              <ProtectedRoute>
                <ArticleFrobes />
              </ProtectedRoute>
            }
          />
        </Routes>
    );
  } else if (location.pathname.startsWith("/admin/templates/cxo")) {
    return (
      <Routes>
        <Route
          path="templates/cxo/:id"
          element={
            <ProtectedRoute>
              <ArticleCXO />
            </ProtectedRoute>
          }
        />
      </Routes>
    );
  }
  else if (location.pathname.startsWith("/admin/website")) {
    return (
        <Routes>
          <Route
            path="website/:id"
            element={
              <ProtectedRoute>
                <WebTemplate />
              </ProtectedRoute>
            }
          />
        </Routes>
    );
  }
  else if (location.pathname.startsWith("/admin/report")) {
    return (
        <Routes>
          <Route
            path="report/:id"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
        </Routes>
    );
  } else if (location.pathname.startsWith("/admin/templates/google")) {
    return (
        <Routes>
          <Route
            path="templates/google/:id"
            element={
              <ProtectedRoute>
                <GoogleTemplate />
              </ProtectedRoute>
            }
          />
        </Routes>
    );
  }

  // For all other routes — normal layout
  return (
    <div style={{ background: "#191A23" }}>
      <Suspense fallback={<div className="p-4"><Loader /></div>}>
        <Container className="px-0 overflow-hidden" fluid>
          <Row>
            <Col md={12}>
              <Header toggleSidebar={toggleSidebar} />
            </Col>
          </Row>
          <Container className="px-0 d-flex" fluid>
            <Sidebar className={`${isSidebarVisible ? "icons-show" : ""} d-block`} />
            <div className={isSidebarVisible ? "icons-show outer-panel pt-0" : "outer-panel pt-0"}>
              <div className="main-panel py-2 px-3">
                <Routes>
                  <Route
                    path="/"
                    element={<ProtectedRoute><Dashboard /></ProtectedRoute>}
                  />
                  <Route
                    path="users"
                    element={<ProtectedRoute><UserList /></ProtectedRoute>}
                  />
                </Routes>
              </div>
              <Footer />
            </div>
          </Container>
        </Container>
      </Suspense>
    </div>
  );
}

export default AdminApp;
